import WhatshotIcon from '@mui/icons-material/Whatshot';
import PageviewIcon from '@mui/icons-material/Pageview';
import KitchenIcon from '@mui/icons-material/Kitchen';
import LuggageIcon from '@mui/icons-material/Luggage';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import CodeIcon from '@mui/icons-material/Code';
import ElectricCarIcon from '@mui/icons-material/ElectricCar';

export const logo = "https://watch-more.com/watch_more.png";

export const categories = [
  { name: "Popular", icon: <WhatshotIcon /> },
  { name: "Discover", icon: <PageviewIcon /> },
  { name: "Cooking", icon: <KitchenIcon /> },
  { name: "Travel", icon: <LuggageIcon /> },
  { name: "Finance", icon: <MonetizationOnIcon /> },
  { name: "Tech", icon: <CodeIcon /> },
  { name: "Cars", icon: <ElectricCarIcon /> }
];

export const listeners = {
  videoSwitch: false,
  sumSwitch: false,
  playSwitch: false
};
